import { provideRouter } from '@angular/router';
import { HttpBackend, provideHttpClient } from '@angular/common/http';
import { routes } from './app.routes';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { TranslateModule, TranslateLoader, TranslatePipe } from '@ngx-translate/core';
import { HttpClientModule } from '@angular/common/http';
import { importProvidersFrom} from '@angular/core';
import { ApplicationConfig } from '@angular/core';
import { MultiTranslateHttpLoader } from 'ngx-translate-multi-http-loader';
import { environment } from '../environments/environment';
import { MaintenanceGuard } from './maintenance/maintenance.guard';
import { MaintenanceService } from './maintenance/maintenance.service';
import { KeyOnlyTranslateLoader } from './core/key-only-translate-loader';

const PHRASEAPP_BASE = 'https://api.viessmann-climatesolutions.com/translations/v2/phraseapp-proxy/projects/';

export function createTranslateLoader(http: HttpBackend) {
  if (window.location.href.includes('showTranslationKeys=true')) {
    return new KeyOnlyTranslateLoader();
  }
  return new MultiTranslateHttpLoader(http, [
    // product-qr-code-landing-page assets
    {
      prefix: `${PHRASEAPP_BASE}488455aebf72a59b3ac03717e9259953/locales/`,
      suffix: '/download?file_format=simple_json'
    },
    // @vi-succ/design-system-web assets
    {
      prefix: `${PHRASEAPP_BASE}ec38b083a23c58c604a49d7f443dd7f2/locales/`,
      suffix: '/download?file_format=simple_json'
    }
  ]);
}
export const provideTranslation = () => ({
    loader: {
      provide: TranslateLoader,
      useFactory: createTranslateLoader,
      deps: [HttpBackend],
    },
  });

  export const appConfig: ApplicationConfig = {
    providers: [
      provideRouter(routes),
      provideAnimationsAsync(),
      provideHttpClient(),
      environment.ENV_PROVIDERS,
      MaintenanceService,
      MaintenanceGuard,
      importProvidersFrom(HttpClientModule), 
      importProvidersFrom([
        TranslateModule.forRoot(provideTranslation()),
        TranslatePipe
    ]),
  ],
  };